import type React from 'react';

import { Helmet } from 'react-helmet-async';

import { usePageOrganizationSchema } from './hooks/usePageOrganizationSchema';

export const PageOrganizationSchema: React.FC = () => {
	const {
		data: { schemaJson },
	} = usePageOrganizationSchema();
	return (
		<Helmet>
			<script type="application/ld+json">{schemaJson}</script>
		</Helmet>
	);
};
